import React, { Component, LegacyRef } from "react";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore,
} from "react-toasts";
import { callApi } from "../../utils/api";
import { showRequiredFieldsToast } from "../../utils/requiredFieldsToast";
import {
  CHECKLIST_SUBMIT_STATUS,
  ChecklistSubmitStatus,
  readChecklistSubmitStatus,
} from "../../utils/checklistSubmitStatus";
import Card from "react-bootstrap/Card";
import Select from "react-select";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import Rotate90DegreesCcwIcon from "@material-ui/icons/Rotate90DegreesCcw";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import { isEmpty } from "lodash";
import PdfHighlighter from "../PDF-Highlighter";
import "../workFileVerificationList/ThreeDotsMenu.css";
import GeneralVerification from "../workFileVerificationList/generalVerification";
import SurveyNoVerification from "../workFileVerificationList/surveyNoVerification";
import Deed from "../workFileVerificationList/deed";
import LegalHerisVerification from "../workFileVerificationList/legalHerisVerify";
import ECVerification from "../workFileVerificationList/ecVerify";
import MissingLOD from "../workFileVerificationList/missingLOD";
import Verification from "../workFileVerificationList/verification";
import CourtDocVerify from "../workFileVerificationList/courtDocVerify";
import Hsdpatta from "../workFileVerificationList/hsdpatta";
import DataModel from "../workFileVerificationList/sopDataModel";
import Nathampatta from "../workFileVerificationList/Nathampatta";
import Flow from "../workFileVerificationList/Flow";
import Propertytax from "../workFileVerificationList/Propertytax";
import EBreceipt from "../workFileVerificationList/EBreceipt";
import OriginalDocVerify from "../workFileVerificationList/OriginalDocVerify";
import TabKeyBlocker from "../Customecomponent/TabKeyBlocker";
import DynamicChecklistRuntime, {
  DynamicChecklistRuntimeValue,
  DynamicChecklistRuntimeApi,
} from "../DynamicChecklistRuntime/DynamicChecklistRuntime";
import { buildDynamicChecklistPersistPayload } from "../../utils/dynamicChecklistScrutinyPrefill";
import { seedLegacyChecklistRestoreKeys } from "../../utils/dynamicChecklistPersistRestore";
import HintAboutFile from "./HintAboutFile";
import {
  clearDocGenTimeout,
  extractAxiosDocGenError,
  isDocGenFailedResponse,
  isDocGenQueued,
  docGenFailureMessage,
  readDocGenTimeout,
  writeDocGenTimeout,
  releaseDocGenClickFreeze,
  pollGeneratedDocx,
  DOC_GEN_TIMEOUT_SEC,
  failWithDocGenTimeout,
  isDocGenWorkerDownError,
} from "../../utils/docGenerationTimeout";

declare var $: any;
interface AllProps {
  history: any;
  match: any;
  location: any;
  verifiedfile: string;
}

export class PocessCheckList extends Component<AllProps> {
  state = {
    base: "",
    data: DataModel,
    report: "",
    reason: "",
    type: "",
    allDocuments: [],
    selectedDoc: "",
    isHightlightsLoaded: false,
    documentWidth: 50,
    documentHeight: 600,
    velocityEqualToMove: false,
    enableVelocity: false,
    rotation: 0,
    docToPreview: false,
    highlights: [],
    deeds: [],
    isOnLoading: false,
    overviewReport: "",
    timer: 0,
    generationTimedOut: false,
    generationError: "",
    formDataLoading: false,
    dynamicChecklist: {
      checklistValues: {},
      repeatableValues: {},
      fieldVerified: {},
    } as DynamicChecklistRuntimeValue,
    dynamicChecklistInitial: null as DynamicChecklistRuntimeValue | null,
    dynamicChecklistPersisted: false,
    dynamicChecklistApi: null as DynamicChecklistRuntimeApi | null,
    checklistSubmitStatus: null as ChecklistSubmitStatus,
    checklistSaving: false,
    checklistDirty: false,
  };
  ignoreChecklistDirty = false;
  document = {
    base: "",
    numPages: 0,
    pageNumber: 1,
  };

  intervalId: NodeJS.Timeout | null = null;
  remarksRef: LegacyRef<HTMLTextAreaElement> = React.createRef();
  timeoutId: any = null;
  generationTimeoutTriggered: boolean = false;

  componentDidMount() {
    this.setState({ data: DataModel });
    this.getFormData();
    this.getDeeds();
    this.getAllDocuments();
    setTimeout(() => {
      var docOverview = localStorage.getItem("overviewDocument");
      const savedError = readDocGenTimeout(this.props.match.params.id);
      if (savedError) {
        this.setState({
          generationTimedOut: true,
          generationError: savedError,
        });
        return;
      }
      if (this.props.match.params.id == localStorage.getItem("currentFile")) {
        if (docOverview != null) {
          this.setState({
            overviewReport: docOverview,
            enableRefresh: true,
            isOnLoading: false,
          });

          $("#root").unbind();
        } else {
          this.scrutinyReport();
          this.intervalId = setInterval(() => {
            this.incrementTimer();
          }, 1000);
        }
      } else {
        this.scrutinyReport();
        this.intervalId = setInterval(() => {
          this.incrementTimer();
        }, 1000);
      }
    }, 2000);
  }
  componentWillUnmount() {
    this.stopPollingAndTimer();
  }

  getAllDocuments = () => {
    callApi("POST", "all_doc_no_list.php", { id: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => {
        const documentList: any = response.data;
        if (documentList.length > 0) {
          const documentValue = response.data[0]
            ? response.data[0]["base_id"]
            : null;
          if (documentValue) {
            this.setState({ selectedDoc: documentValue }, () => {
              this.viewDocument(documentValue);
            });
          }
        }
        this.setState({ allDocuments: response.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  viewDocument = (id) => {
    this.setState({ isHightlightsLoaded: false });
    callApi("POST", "getbaseby_id.php", { id })
      .then((res) => res.data)
      .then((response) => {
        if (response.data && response.data.length) {
          this.getScrutinizedDocs(id);
          const document = this.document;
          document.base = response.data[0].base[0].base;
          this.setState(
            {
              ...document,
              selectedDoc: id,
              base: response.data[0].base[0].base,
            },
            () => this.setState({ isHightlightsLoaded: true })
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  previewDynamicEntryDocument = (payload: { docNo?: string; baseId?: string }) => {
    const docs: any[] = Array.isArray(this.state.allDocuments) ? this.state.allDocuments : [];
    let baseId = String(payload?.baseId ?? "").trim();
    const docNo = String(payload?.docNo ?? "").trim();

    if (!baseId && docNo) {
      const match = docs.find((d: any) => {
        const idVal = String(d?.id ?? "").trim();
        const deedRef = String(d?.deedReference ?? "").trim();
        return idVal === docNo || deedRef === docNo;
      });
      if (match?.base_id != null) baseId = String(match.base_id).trim();
    }

    if (!baseId) {
      ToastsStore.error("Preview not available for this entry document");
      return;
    }
    this.viewDocument(baseId);
  };

  getTemplates = (deed) => {
    callApi("POST", "template_list_bydeed.php", { deed })
      .then((res) => res.data)
      .then((response) => {
        this.setState({ templates: response.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getDynamicFields = (id) => {
    callApi("POST", "input_master_get.php", { id })
      .then((res) => res.data)
      .then((response) => {
        if (response.data && response.data.length) {
          response.data.map((dynamic) => {
            if (dynamic.type === "select") {
              const patchDynamicField: any = [];
              const fieldSelected = !isEmpty(this.state[dynamic.name])
                ? this.state[dynamic.name].split(",")
                : [];
              fieldSelected.map((val) => {
                const selField: any = dynamic.optionList.find(
                  (all: any) => all.name === val
                );
                patchDynamicField.push(selField);
              });
              this.setState({
                [dynamic.name]: patchDynamicField,
                modifySelectToCommas: [dynamic.name],
              });
            }
          });
          this.setState({ dynamicFields: response.data });
        } else {
          this.setState({ dynamicFields: [] });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  manageStaticFields = (id) => {
    callApi("POST", "dynamic_form.php", { id })
      .then((res) => res.data)
      .then((response) => {
        this.setState({ staticFilesToHide: response.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getScrutinizedDocs = (id) => {
    callApi("POST", "doc_scrutinize_get.php", {
      id: id,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response.data && response.data.length) {
          const state = response.data[0].scrutinize[0];
          // state.base = response.data[0].base[0].base;
          if (state.nature_doc) {
            this.getTemplates(state.nature_doc);
          }
          state.main_favour = response.data[0].favour;
          state.main_executant = response.data[0].executant;
          state.highlights = response.data[0].highlights || [];
          state.sheetCount = response.data[0].sheetCount || "";
          if (!state.main_favour || !state.main_favour.length) {
            state.main_favour = [];
            state.main_favour.push({ favour: "" });
          }
          if (!state.main_executant || !state.main_executant.length) {
            state.main_executant = [];
            state.main_executant.push({ executant: "" });
          }
          if (state.template) {
            this.getDynamicFields(state.template);
            this.manageStaticFields(state.template);
          }
          const deedSelected = state.deed ? state.deed.split(",") : [];
          state.deed = [];
          deedSelected.forEach((deed) => {
            const selDeed: any = this.state.deeds.find(
              (all: any) => all.id === deed
            );
            state.deed.push(selDeed);
          });
          this.setState({ ...state, isHightlightsLoaded: true });
        }
        this.getDeeds();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getDeeds = () => {
    callApi("POST", "deed_master_get.php", { category: this.state.type })
      .then((res) => res.data)
      .then((response) => {
        if (response.data && response.data.length) {
          const deeds = response.data;
          this.setState({ deeds });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  onHighlightsChange = (highlights) => {
    this.setState({ highlights });
  };
  rotate = () => {
    let newRotation = this.state.rotation + 90;
    if (newRotation >= 360) {
      newRotation = -360;
    }
    this.setState({ rotation: newRotation });
  };
  incrementTimer = () => {
    if (this.state.generationTimedOut || this.state.overviewReport) {
      return;
    }
    this.setState(
      (prevState: any) => ({
        timer: prevState.timer + 1,
      }),
      () => {
        if (
          this.state.timer >= DOC_GEN_TIMEOUT_SEC &&
          !this.state.generationTimedOut &&
          !this.state.overviewReport &&
          !this.generationTimeoutTriggered
        ) {
          failWithDocGenTimeout((message) =>
            this.handleGenerationFailure(message),
          );
        }
      },
    );
  };
  scrutinyReport = () => {
    if (this.state.generationTimedOut || this.generationTimeoutTriggered) {
      this.stopPollingAndTimer();
      return;
    }
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    callApi("POST", "template/tests/scrutiny_report_zmq.php", {
      file_idfk: this.props.match.params.id,
      check: false,
      userId,
    })
      .then((res) => res.data)
      .then((response) => {
        if (isDocGenFailedResponse(response)) {
          this.handleGenerationFailure(docGenFailureMessage(response));
          return;
        }
        if (isDocGenQueued(response)) {
          localStorage.setItem("serverLocalFileName", response.local_file_name);
          this.setState({ serverLocalFileName: response.local_file_name });
          this.finalReport(response);
          return;
        }
        this.handleGenerationFailure(
          docGenFailureMessage(
            response,
            "Word document generation service is unreachable. Please contact the Support Team",
          ),
        );
      })
      .catch((err) => {
        console.log(err);
        this.handleGenerationFailure(extractAxiosDocGenError(err));
      });
  };
  finalReport = (zmqresponse) => {
    pollGeneratedDocx({
      url: zmqresponse.doc_path,
      isCancelled: () =>
        this.state.generationTimedOut || this.generationTimeoutTriggered,
      onReady: () => {
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
          this.timeoutId = null;
        }
        localStorage.setItem("verify-overviewDocument", zmqresponse.data);
        var currentFile = zmqresponse.file_name.split("-");
        localStorage.setItem("currentFile", currentFile[1]);
        this.stopTimer();
        clearDocGenTimeout(this.props.match.params.id);
        this.setState({
          overviewReport: zmqresponse.data,
          enableRefresh: true,
          isOnLoading: false,
        });
        releaseDocGenClickFreeze();
      },
      onFailure: (message) => this.handleGenerationFailure(message),
      schedule: (fn, ms) => {
        this.timeoutId = setTimeout(fn, ms);
      },
    });
  };
  stopTimer() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
  stopPollingAndTimer = () => {
    this.stopTimer();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  };
  handleGenerationFailure = (detail: string) => {
    this.stopPollingAndTimer();
    this.generationTimeoutTriggered = true;
    releaseDocGenClickFreeze();
    const error = (detail || "Document generation failed.").trim();
    writeDocGenTimeout(this.props.match.params.id, error);
    this.setState({
      generationTimedOut: true,
      generationError: error,
      isOnLoading: false,
    });
  };
  retryDocumentGeneration = () => {
    clearDocGenTimeout(this.props.match.params.id);
    window.location.reload();
  };

  /** Regenerate Software Generated Copy after checklist mapped values are written back. */
  reloadSoftwareGeneratedCopy = () => {
    this.stopTimer();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    this.setState({
      overviewReport: "",
      timer: 0,
      enableRefresh: false,
      isOnLoading: true,
    });
    this.intervalId = setInterval(() => {
      this.incrementTimer();
    }, 1000);
    this.scrutinyReport();
  };

  // getFormData = () => {
  //   const user: any = localStorage.getItem("user");
  //   const userId = user ? JSON.parse(user)["userId"] : "";
  //   const fileId = this.props.match.params.id;
  //   callApi("POST", "get_process_checklist.php", {
  //     fileNo: fileId,
  //     userId,
  //   })
  //     .then((res) => res.data)
  //     .then((response) => {
  //       if (response?.responseJson?.data?.currentJson) {
  //         this.setState({
  //           data: JSON.parse(response?.responseJson?.data?.currentJson),
  //         });
  //       } else {
  //         this.setState({ data: DataModel });
  //         this.getVerificationListData();
  //       }
  //     })
  //     .catch((err) => {
  //       this.setState({ data: DataModel });
  //       this.getVerificationListData();
  //     });
  // };
  // getVerificationListData = () => {
  //   const fileId = this.props.match.params.id;
  //   callApi("POST", "get_verification.php", {
  //     fileNo: fileId,
  //   })
  //     .then((res) => res.data)
  //     .then((response) => {
  //       if (response && response.data) {
  //         let modifiedData = { ...this.state.data };
  //         Object.entries(response.data).forEach((data: any) => {
  //           if (data[0] && data[1]) {
  //             modifiedData = {
  //               ...modifiedData,
  //               [data[0]]: {
  //                 ...modifiedData[data[0]],
  //                 ...data[1],
  //               },
  //             };
  //           }
  //         });
  //         this.setState({
  //           data: modifiedData,
  //         });
  //       } else {
  //         this.setState({ data: DataModel });
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
// Helper function to check if value has actual data
hasValue = (value: any): boolean => {
  return value !== undefined && value !== null && value !== '';
};

// Helper function to conditionally add a field only if it has a value
addIfHasValue = (obj: any, key: string, value: any) => {
  if (this.hasValue(value)) {
    obj[key] = value;
  }
};

// 1. Map propertyDetails with all fields from API - DO NOT MAP "verified" fields
mapPropertyDetails = (propertyDetails: any = {}) => {
  const mapped: any = {};
  
  // Only add fields that have values
  if (this.hasValue(propertyDetails.ownerAadharName)) {
    mapped.ownerAadharName = { value: propertyDetails.ownerAadharName };
  }
  
  if (this.hasValue(propertyDetails.borrowerAadharName)) {
    mapped.borrowerAadharName = { value: propertyDetails.borrowerAadharName };
  }
  
  if (this.hasValue(propertyDetails.coBorrowerAadharName)) {
    mapped.coBorrowerAadharName = { value: propertyDetails.coBorrowerAadharName };
  }
  
  // FIX: Handle addressofProperty specially - it's an object with multiple address lines
  const addressRaw =
    propertyDetails.addressofProperty ?? propertyDetails.addressOfProperty;
  if (addressRaw) {
    const addressObj = Array.isArray(addressRaw)
      ? addressRaw.reduce((acc: any, line: any, idx: number) => {
          const s = line == null ? "" : String(line).trim();
          if (s) acc[String(idx + 1)] = s;
          return acc;
        }, {})
      : addressRaw;

    // Check if it's an object with numeric keys
    if (addressObj && typeof addressObj === 'object') {
      // Create a new object for the address
      const addressData: any = {};
      
      // Copy all numeric properties as-is (for multiple address lines)
      Object.keys(addressObj).forEach(key => {
        // Check if key is numeric or string
        if (!isNaN(Number(key)) || key === 'verified' || key === 'value') {
          addressData[key] = addressObj[key];
        }
      });
      
      // Make sure we have at least one address line
      // If no verified property, add it as false by default
      if (addressData.verified === undefined) {
        addressData.verified = false;
      }
      
      mapped.addressofProperty = addressData;
    } else {
      // If it's a simple string, wrap it with verified false
      mapped.addressofProperty = { 
        "1": addressObj, 
        verified: false 
      };
    }
  }
  
  if (this.hasValue(propertyDetails.AppIdverfy)) {
    mapped.AppIdverfy = { value: propertyDetails.AppIdverfy };
  }
  
  // ownerShip has a default value
  if (this.hasValue(propertyDetails.ownerShip)) {
    mapped.ownerShip = { value: propertyDetails.ownerShip };
  } else {
    mapped.ownerShip = { value: "Individual" };
  }

  return mapped;
};

// 2. Map missingLOD correctly - NO BOOLEAN FIELDS
mapMissingLOD = (missingLOD: any = {}) => {
  const result: any = {
    missingLOD: {
      sheets: []
    }
  };

  if (missingLOD && missingLOD.sheets && Array.isArray(missingLOD.sheets)) {
    result.missingLOD.sheets = missingLOD.sheets.map((item: any) => {
      const mappedItem: any = {};
      
      this.addIfHasValue(mappedItem, 'fileNo', item.fileNo);
      this.addIfHasValue(mappedItem, 'fileName', item.fileName);
      this.addIfHasValue(mappedItem, 'totalSheets', item.totalSheets);
      this.addIfHasValue(mappedItem, 'availableSheets', item.availableSheets);
      this.addIfHasValue(mappedItem, 'missingSheets', item.missingSheets);
      this.addIfHasValue(mappedItem, 'missingSheetsNumbers', item.missingSheetsNumbers);
      // isCertificateAttached: REMOVED - comes from process_checklist only
      
      return mappedItem;
    });
  }

  return result;
};

// 3. Map surveyNoVerification with all fields - NO BOOLEAN FIELDS
mapSurveyVerification = (survey: any = {}) => {  
  const result: any = {
    surveyNoVerification: {
      titleDeed: [],
      currentPatta: [],
      register: [],
    }
  };

  // Only add top-level fields that have values
  this.addIfHasValue(result.surveyNoVerification, 'totalTitleDeed', survey.totalTitleDeed);
  this.addIfHasValue(result.surveyNoVerification, 'totalEc', survey.totalEc);
  this.addIfHasValue(result.surveyNoVerification, 'difference', survey.difference);
  this.addIfHasValue(result.surveyNoVerification, 'missingEc', survey.missingEc);
  this.addIfHasValue(result.surveyNoVerification, 'type', survey.type);
  this.addIfHasValue(result.surveyNoVerification, 'pattaissuedverfy', survey.pattaissuedverfy);
  // pattaqrcode: REMOVED - boolean, comes from process_checklist/DataModel only
  // proofverifyqrcode: REMOVED - boolean, comes from process_checklist/DataModel only

  // Map titleDeed from API response - NO BOOLEAN FIELDS
  if (survey.titleDeed && Array.isArray(survey.titleDeed)) {
    console.log(`Mapping ${survey.titleDeed.length} titleDeed items`);
    
    result.surveyNoVerification.titleDeed = survey.titleDeed.map((item: any, index: number) => {
      console.log(`Processing titleDeed item ${index}:`, item);
      
      const mappedItem: any = {};

      // Only add fields that have values - Data from API - ONLY TEXT/NUMBER FIELDS, NO BOOLEANS
      this.addIfHasValue(mappedItem, 'fd_id', item.fd_id);
      this.addIfHasValue(mappedItem, 'surveyNo', item.surveyNo);
      this.addIfHasValue(mappedItem, 'oldSurveyNo', item.oldSurveyNo);
      this.addIfHasValue(mappedItem, 'extent', item.extent);
      this.addIfHasValue(mappedItem, 'name', item.name);
      this.addIfHasValue(mappedItem, 'deedlayoutnameverfy', item.deedlayoutnameverfy);
      this.addIfHasValue(mappedItem, 'deedstreetnameverfy', item.deedstreetnameverfy);
      this.addIfHasValue(mappedItem, 'deedplotNoverfy', item.deedplotNoverfy);
      this.addIfHasValue(mappedItem, 'measurementextentmatch', item.measurementextentmatch);
      this.addIfHasValue(mappedItem, 'deedDoorNoverfy', item.deedDoorNoverfy);
      this.addIfHasValue(mappedItem, 'deedflatnoverfy', item.deedflatnoverfy);
      this.addIfHasValue(mappedItem, 'floor', item.floor);
      this.addIfHasValue(mappedItem, 'deedapartnameverfy', item.deedapartnameverfy);
      this.addIfHasValue(mappedItem, 'boundverfyNorth', item.boundverfyNorth);
      this.addIfHasValue(mappedItem, 'boundverfySouth', item.boundverfySouth);
      this.addIfHasValue(mappedItem, 'boundverfyEast', item.boundverfyEast);
      this.addIfHasValue(mappedItem, 'boundverfyWest', item.boundverfyWest);
      this.addIfHasValue(mappedItem, 'Corelation', item.Corelation);
      this.addIfHasValue(mappedItem, 'proceedingpatta', item.proceedingpatta);
      this.addIfHasValue(mappedItem, 'deedExtentverfy', item.deedExtentverfy);
      this.addIfHasValue(mappedItem, 'sROVerified', item.sROVerified);
      this.addIfHasValue(mappedItem, 'tslrNo', item.tslrNo);

      // Extract boundary measurements if available
      if (Array.isArray(item.boundaries)) {
        console.log(`Item ${index} has boundaries:`, item.boundaries);
        item.boundaries.forEach((b: any) => {
          this.addIfHasValue(mappedItem, 'northeastMeasur', b.northeastMeasur);
          this.addIfHasValue(mappedItem, 'southeastMeasur', b.southeastMeasur);
          this.addIfHasValue(mappedItem, 'eastnorthMeasur', b.eastnorthMeasur);
          this.addIfHasValue(mappedItem, 'westnorthMeasur', b.westnorthMeasur);
        });
      }
      
      // ALL BOOLEAN FIELDS REMOVED - will come from process_checklist/DataModel only:
      // roadAppBound, pathwayBound, ofbyBoundverfy, landTypeNanjai, NonAgrifromtashidar,
      // newtalukVerified, deedapartcompletioncert, deedvillagename, deedregisterdistrict

      return mappedItem;
    });
  } else {
    console.log("No titleDeed array found or it's empty");
  }

  // Map currentPatta from API response - NO BOOLEAN FIELDS
  if (survey.currentPatta && Array.isArray(survey.currentPatta)) {
    result.surveyNoVerification.currentPatta = survey.currentPatta.map((item: any) => {
      const mappedItem: any = {};
      
      this.addIfHasValue(mappedItem, 'surveyNo', item.surveyNo);
      this.addIfHasValue(mappedItem, 'tslrNo', item.tslrNo);
      this.addIfHasValue(mappedItem, 'extent', item.extent);
      this.addIfHasValue(mappedItem, 'name', item.name);
      // governmentLandorNotverify: REMOVED - boolean, comes from process_checklist/DataModel only
      
      return mappedItem;
    });
  }

  // Map register from API response - NO BOOLEAN FIELDS
  if (survey.register && Array.isArray(survey.register)) {
    result.surveyNoVerification.register = survey.register.map((item: any) => {
      const mappedItem: any = {};
      
      this.addIfHasValue(mappedItem, 'surveyNo', item.surveyNo);
      this.addIfHasValue(mappedItem, 'tslrNo', item.tslrNo);
      this.addIfHasValue(mappedItem, 'extent', item.extent);
      this.addIfHasValue(mappedItem, 'name', item.name);
      this.addIfHasValue(mappedItem, 'aRegisterMeanscompare', item.aRegisterMeanscompare);
      // registerVerified: REMOVED - boolean, comes from process_checklist/DataModel only
      
      return mappedItem;
    });
  }

  console.log("Final mapped surveyNoVerification:", result.surveyNoVerification);
  return result;
};

// 4. Map deed data for ALL deed types - NO BOOLEAN FIELDS
mapDeedData = (deed: any = {}) => {
  const mapped: any = {
    deed: {}
  };

  // Helper function to create deed entry - ONLY TEXT FIELDS
  const createDeedEntry = (item: any, type: string) => {
    const base: any = {};
    
    this.addIfHasValue(base, 'derivedBy', item.surveyNo || item.derivedBy);
    this.addIfHasValue(base, 'extent', item.extent);
    this.addIfHasValue(base, 'deedReference', item.deedReference);
    // registered: REMOVED - boolean, comes from process_checklist/DataModel only

    // Add relationship field based on deed type
    const relationship = item.relationship || 
                        item.relationshipMentioned || 
                        item.willdeadreationship || 
                        item.relationShipmentioned || 
                        item.partionRelationship;

    switch(type) {
      case "saleDeed":
        this.addIfHasValue(base, 'relationship', relationship);
        this.addIfHasValue(base, 'saleDeedConditions', item.saleDeedConditions);
        // ALL BOOLEAN FIELDS REMOVED:
        // saleDeedAmountTransfered, saleDeedConditionsMentioned
        break;
      case "giftDeed":
        this.addIfHasValue(base, 'relationshipMentioned', relationship);
        this.addIfHasValue(base, 'mentionCondition', item.mentionCondition);
        // ALL BOOLEAN FIELDS REMOVED:
        // condition, conditionFulfilled, deathcertificateobtained
        break;
      case "settlementDeed":
        this.addIfHasValue(base, 'relationshipMentioned', relationship);
        this.addIfHasValue(base, 'mentionCondition', item.mentionCondition);
        // ALL BOOLEAN FIELDS REMOVED:
        // condition, conditionFulfilled, deathcertificateobtained
        break;
      case "partitionDeed":
        this.addIfHasValue(base, 'partionRelationship', relationship);
        this.addIfHasValue(base, 'partionscheduleMortage', item.partionscheduleMortage);
        this.addIfHasValue(base, 'partionsimulatenous', item.partionsimulatenous);
        this.addIfHasValue(base, 'mentionCondition', item.mentionCondition);
        this.addIfHasValue(base, 'docAllotedForMortgage', item.docAllotedForMortgage);
        this.addIfHasValue(base, 'originalCopyAvailable', item.originalCopyAvailable);
        // ALL BOOLEAN FIELDS REMOVED:
        // condition, partiondeathcertobtin, conditionFulfilled
        break;
      case "willDeed":
        this.addIfHasValue(base, 'willdeadreationship', relationship);
        this.addIfHasValue(base, 'mentionCondition', item.mentionCondition);
        // ALL BOOLEAN FIELDS REMOVED:
        // condition, conditionFulfilled, willdeedcertcopyverify, willdeaddeathcert
        break;
      case "leaseDeed":
        this.addIfHasValue(base, 'relationship', relationship);
        this.addIfHasValue(base, 'leasePeriodFromDate', item.leasePeriodFromDate);
        this.addIfHasValue(base, 'leasePeriodToDate', item.leasePeriodToDate);
        // ALL BOOLEAN FIELDS REMOVED:
        // nocAvailable, leaseDeedempowermortage, leaseDeedCancellation
        break;
      case "attorneyDeed":
        this.addIfHasValue(base, 'relationship', relationship);
        // ALL BOOLEAN FIELDS REMOVED:
        // isInForce, isCertifiedCopyAvailable, attorneyDeedmortage, 
        // attorneyDeedsaleReceipt, attorneyLifecert
        break;
      case "releaseDeed":
        this.addIfHasValue(base, 'relationShipmentioned', relationship);
        this.addIfHasValue(base, 'propertyshare', item.propertyshare);
        this.addIfHasValue(base, 'mentionCondition', item.mentionCondition);
        // ALL BOOLEAN FIELDS REMOVED:
        // condition, fulFilled, deatcertficate
        break;
      case "rectificationDeed":
        this.addIfHasValue(base, 'relationship', relationship);
        this.addIfHasValue(base, 'mentionDetails', item.mentionDetails);
        this.addIfHasValue(base, 'correctDetails', item.correctDetails || item.correctDetailsx);
        break;
      case "consentDeed":
        this.addIfHasValue(base, 'relationship', relationship);
        this.addIfHasValue(base, 'reason', item.reason);
        // agecheckAadhar: REMOVED - boolean, comes from process_checklist/DataModel only
        break;
      case "gazetteofDoc":
        this.addIfHasValue(base, 'relationship', relationship);
        break;
    }
    
    return base;
  };

  // Process all deed types from API
  const deedTypes = [
    { key: "saleDeed", data: deed.saleDeed },
    { key: "giftDeed", data: deed.giftDeed },
    { key: "settlementDeed", data: deed.settlementDeed },
    { key: "partitionDeed", data: deed.partitionDeed },
    { key: "willDeed", data: deed.willDeed },
    { key: "leaseDeed", data: deed.leaseDeed },
    { key: "attorneyDeed", data: deed.attorneyDeed },
    { key: "releaseDeed", data: deed.releaseDeed },
    { key: "rectificationDeed", data: deed.rectificationDeed },
    { key: "consentDeed", data: deed.consentDeed },
    { key: "gazetteofDoc", data: deed.gazetteofDoc },
  ];

  deedTypes.forEach(({ key, data }) => {
    if (data && Array.isArray(data)) {
      mapped.deed[key] = data.map((item: any) => createDeedEntry(item, key));
    } else {
      // If no data from API, create empty array
      mapped.deed[key] = [];
    }
  });

  // Handle foreignPower separately - NO BOOLEAN FIELDS
  if (deed.foriegnPower && Array.isArray(deed.foriegnPower) && deed.foriegnPower.length > 0) {
    const docNo = deed.foriegnPower[0].docNo;
    if (this.hasValue(docNo)) {
      mapped.deed.foriegnPower = {
        // isForiegnPowerRegistered: REMOVED - boolean, comes from process_checklist/DataModel only
        docNo: docNo,
      };
    }
  }

  return mapped;
};

// 5. Map EB receipt data - NO BOOLEAN FIELDS
mapEBreceiptData = (ebData: any = {}) => {
  const result: any = {
    EBreceiptData: {
      EBreceipt: []
    }
  };

  if (ebData && ebData.EBreceipt && Array.isArray(ebData.EBreceipt)) {
    result.EBreceiptData.EBreceipt = ebData.EBreceipt.map((item: any) => {
      const mappedItem: any = {};
      
      this.addIfHasValue(mappedItem, 'dateVerified', item.dateVerified);
      this.addIfHasValue(mappedItem, 'propertOwnerVerify', item.propertOwnerVerify);
      this.addIfHasValue(mappedItem, 'ebAmountverify', item.ebAmountverify);
      this.addIfHasValue(mappedItem, 'receiptIssuedByVerify', item.receiptIssuedByVerify);
      
      return mappedItem;
    });
  }

  return result;
};

// 6. Map property tax data - NO BOOLEAN FIELDS
mapPropertyTaxData = (propertyTax: any = {}) => {
  const result: any = {
    propertytax: {
      propertytax: []
    }
  };

  if (propertyTax && propertyTax.propertytax && Array.isArray(propertyTax.propertytax)) {
    result.propertytax.propertytax = propertyTax.propertytax.map((item: any) => {
      const mappedItem: any = {};
      
      this.addIfHasValue(mappedItem, 'dataVerified', item.dataVerified);
      this.addIfHasValue(mappedItem, 'propertOwnerVerify', item.propertOwnerVerify);
      this.addIfHasValue(mappedItem, 'propertyAmountverify', item.propertyAmountverify);
      this.addIfHasValue(mappedItem, 'doorNoVerify', item.doorNoVerify);
      this.addIfHasValue(mappedItem, 'assessmentVerifi', item.assessmentVerifi);
      this.addIfHasValue(mappedItem, 'propertyTaxVerify', item.propertyTaxVerify);
      this.addIfHasValue(mappedItem, 'deedReference', item.deedReference);
      // ALL BOOLEAN FIELDS REMOVED:
      // propertyTaxVerifyQrcode, attachProofVerifyQrcode
      
      return mappedItem;
    });
  }

  return result;
};

// 7. Map legal heirs data from API - NO BOOLEAN FIELDS
mapLegalHeirsData = (legalHeirsData: any = {}) => {
  const result: any = {
    legalHeirsVerify: {
      legalHeirs: []
    }
  };

  if (legalHeirsData && legalHeirsData.legalHeirs && Array.isArray(legalHeirsData.legalHeirs)) {
    // Merge all legalHeirs entries into one object
    const mergedLegalHeirs: any = {};
    // ALL BOOLEAN FIELDS REMOVED:
    // legalHeirsWithin13, PredeceasedlegalHeire, legalHeirsWithqrcode, legalHeirsattacedproof

    // Combine data from all legalHeirs entries - only fields with values
    legalHeirsData.legalHeirs.forEach((item: any) => {
      this.addIfHasValue(mergedLegalHeirs, 'legalHeirsObtained', item.legalHeirsObtained);
      this.addIfHasValue(mergedLegalHeirs, 'geanology', item.geanology);
      this.addIfHasValue(mergedLegalHeirs, 'docNoAndYear', item.docNoAndYear);
      this.addIfHasValue(mergedLegalHeirs, 'nextDeedDocNoAndYear', item.nextDeedDocNoAndYear);
    });

    result.legalHeirsVerify.legalHeirs = [mergedLegalHeirs];
  }

  return result;
};

// 8. Map HSD pattas data from API - NO BOOLEAN FIELDS
mapHsdpPattaData = (hsdpData: any = {}) => {
  const result: any = {
    HsdpattasVerify: {
      Hsdpattas: []
    }
  };

  if (hsdpData && hsdpData.Hsdpattas && Array.isArray(hsdpData.Hsdpattas) && hsdpData.Hsdpattas.length > 0) {
    result.HsdpattasVerify.Hsdpattas = hsdpData.Hsdpattas.map((item: any) => {
      const mappedItem: any = {};
      
      this.addIfHasValue(mappedItem, 'hsdpattaissuedby', item.hsdpattaissuedby);
      this.addIfHasValue(mappedItem, 'mentionCondition', item.mentionCondition);
      // ALL BOOLEAN FIELDS REMOVED:
      // roadApproachs, certificate, nocforTahsildar, conditionFullfilled
      
      return mappedItem;
    });
  }

  return result;
};

// 9. Complete normalizeDynamicChecklist function
normalizeDynamicChecklist = (apiData: any = {}) => {
  let normalized: any = {};

  // 1. Map propertyDetails
  if (apiData.propertyDetails) {
    normalized.generalVerification = this.mapPropertyDetails(apiData.propertyDetails);
  }

  // 2. Map missingLOD
  if (apiData.missingLOD) {
    const missingData = this.mapMissingLOD(apiData.missingLOD);
    normalized.missingLOD = missingData.missingLOD;
  }

  // 3. Map survey verification
  if (apiData.surveyNoVerification) {
    const surveyData = this.mapSurveyVerification(apiData.surveyNoVerification);
    normalized.surveyNoVerification = surveyData.surveyNoVerification;
  }

  // 4. Map deed data
  if (apiData.deed) {
    const deedData = this.mapDeedData(apiData.deed);
    normalized.deed = deedData.deed;
  }

  // 5. Map EB receipt
  if (apiData.EBreceiptData) {
    const ebData = this.mapEBreceiptData(apiData.EBreceiptData);
    normalized.EBreceiptData = ebData.EBreceiptData;
  }

  // 6. Map property tax
  if (apiData.propertytax) {
    const taxData = this.mapPropertyTaxData(apiData.propertytax);
    normalized.propertytax = taxData.propertytax;
  }

  // 7. Map legal heirs
  if (apiData.legalHeirsVerify) {
    const legalHeirsData = this.mapLegalHeirsData(apiData.legalHeirsVerify);
    normalized.legalHeirsVerify = legalHeirsData.legalHeirsVerify;
  }

  // 8. Map HSD pattas
  if (apiData.HsdpattasVerify) {
    const hsdpData = this.mapHsdpPattaData(apiData.HsdpattasVerify);
    normalized.HsdpattasVerify = hsdpData.HsdpattasVerify;
  }

  if (
    apiData.generalDetailsByDocument &&
    typeof apiData.generalDetailsByDocument === "object"
  ) {
    normalized.generalDetailsByDocument = apiData.generalDetailsByDocument;
  }

  if (Array.isArray(apiData.surveyDocuments)) {
    normalized.surveyDocuments = apiData.surveyDocuments;
  }

  return normalized;
};

getFormData = () => {
  const user: any = localStorage.getItem("user");
  const userId = user ? JSON.parse(user)["userId"] : "";
  const fileId = this.props.match.params.id;

  this.setState({ formDataLoading: true });

  // List of fields that should ONLY come from process_checklist or DataModel
  const booleanOnlyFields = new Set([
    // propertyDetails verified fields
    'generalVerification.ownerAadharName.verified',
    'generalVerification.borrowerAadharName.verified',
    'generalVerification.coBorrowerAadharName.verified',
    'generalVerification.addressofProperty.verified',
    'generalVerification.natureofProperty.verified',
    'generalVerification.AppIdverfy.verified',
    'generalVerification.freeRleasehold.verified',
    'generalVerification.ownerShip.verified',
    
    // surveyNoVerification section-level boolean fields
    'surveyNoVerification.pattaqrcode',
    'surveyNoVerification.proofverifyqrcode',
    'surveyNoVerification.conditionPatta',
    
    // surveyNoVerification.titleDeed array boolean fields
    'surveyNoVerification.titleDeed.roadAppBound',
    'surveyNoVerification.titleDeed.pathwayBound',
    'surveyNoVerification.titleDeed.ofbyBoundverfy',
    'surveyNoVerification.titleDeed.landTypeNanjai',
    'surveyNoVerification.titleDeed.NonAgrifromtashidar',
    'surveyNoVerification.titleDeed.newtalukVerified',
    'surveyNoVerification.titleDeed.deedapartcompletioncert',
    'surveyNoVerification.titleDeed.deedvillagename',
    'surveyNoVerification.titleDeed.deedregisterdistrict',
    'surveyNoVerification.titleDeed.new',
    
    // surveyNoVerification.currentPatta array boolean fields
    'surveyNoVerification.currentPatta.governmentLandorNotverify',
    
    // surveyNoVerification.register array boolean fields
    'surveyNoVerification.register.registerVerified',
  ]);

  // Smart merge that respects field priority and boolean-only restrictions
  const smartMerge = (target: any, source: any, trackedFields: Set<string>, parentPath: string = "", skipBooleanOnlyFields: boolean = false) => {
    if (!source || typeof source !== "object") return;
    
    for (const key in source) {
      if (!source.hasOwnProperty(key)) continue;
      
      const val = source[key];
      const currentPath = parentPath ? `${parentPath}.${key}` : key;
      
      // Skip boolean-only fields if this source is not allowed to set them
      if (skipBooleanOnlyFields && booleanOnlyFields.has(currentPath)) {
        continue;
      }
      
      // Handle arrays
      if (Array.isArray(val)) {
        if (!target[key] || !Array.isArray(target[key])) {
          target[key] = [];
        }
        
        // Merge array items
        val.forEach((item, idx) => {
          if (!target[key][idx]) {
            target[key][idx] = {};
          }
          
          if (item && typeof item === "object" && !Array.isArray(item)) {
            // For array items, check if any of their properties are boolean-only fields
            for (const itemKey in item) {
              if (!item.hasOwnProperty(itemKey)) continue;
              
              const itemPath = `${currentPath}.${itemKey}`;
              const itemVal = item[itemKey];
              
              // Skip boolean-only fields
              if (skipBooleanOnlyFields && booleanOnlyFields.has(itemPath)) {
                continue;
              }
              
              const fullPath = `${currentPath}[${idx}].${itemKey}`;
              
              if (itemVal && typeof itemVal === "object" && !Array.isArray(itemVal)) {
                if (!target[key][idx][itemKey]) {
                  target[key][idx][itemKey] = {};
                }
                smartMerge(target[key][idx][itemKey], itemVal, trackedFields, fullPath, skipBooleanOnlyFields);
              } else if (itemVal !== undefined && itemVal !== null && itemVal !== '') {
                if (!trackedFields.has(fullPath)) {
                  target[key][idx][itemKey] = itemVal;
                  trackedFields.add(fullPath);
                }
              }
            }
          } else if (item !== undefined && item !== null && item !== '') {
            const fieldPath = `${currentPath}[${idx}]`;
            if (!trackedFields.has(fieldPath)) {
              target[key][idx] = item;
              trackedFields.add(fieldPath);
            }
          }
        });
      } 
      // Handle objects
      else if (val && typeof val === "object" && !Array.isArray(val)) {
        if (!target[key] || typeof target[key] !== "object") {
          target[key] = {};
        }
        smartMerge(target[key], val, trackedFields, currentPath, skipBooleanOnlyFields);
      } 
      // Handle primitive values (including booleans, strings, numbers)
      else if (val !== undefined && val !== null && val !== '') {
        // Only set if this field hasn't been set before
        if (!trackedFields.has(currentPath)) {
          target[key] = val;
          trackedFields.add(currentPath);
        }
      }
    }
  };

  // 1. get_dynamic_verificationchecklist.php
  const dynamicPromise = callApi("POST", "get_dynamic_verificationchecklist.php", {
    fileNo: fileId,
    userId,
  })
    .then((res) => res.data)
    .then((response) => (response?.data ? this.normalizeDynamicChecklist(response.data) : {}))
    .catch(() => ({}));

  // 2. get_verification.php
  const verificationPromise = callApi("POST", "get_verification.php", {
    fileNo: fileId,
  })
    .then((res) => res.data)
    .then((response) => response?.data || {})
    .catch(() => ({}));

  // 3. get_process_checklist.php
  const processChecklistPromise = callApi("POST", "get_process_checklist.php", {
    fileNo: fileId,
    userId,
  })
    .then((res) => res.data)
    .then((response) => {
      if (response?.responseJson?.data?.currentJson) {
        try {
          return JSON.parse(response.responseJson.data.currentJson);
        } catch {
          return {};
        }
      }
      return {};
    })
    .catch(() => ({}));

  // Resolve all promises
  Promise.all([dynamicPromise, verificationPromise, processChecklistPromise])
    .then(([dynamicData, verificationData, processChecklistData]) => {
      // Start with DataModel as base
      let finalData = JSON.parse(JSON.stringify(DataModel)); // Deep clone
      
      // Track which fields have been set (to prevent overwriting)
      const trackedFields = new Set<string>();
      
      // Priority order (first one wins):
      // 1. Process Checklist API (saved checklist snapshot must win)
      if (Object.keys(processChecklistData).length > 0) {
        console.log("Merging Process Checklist API data (Priority 1) - includes boolean-only fields");
        smartMerge(finalData, processChecklistData, trackedFields, "", false);
      }
      
      // 2. Dynamic API (fills missing fields only) - SKIP boolean-only fields
      if (Object.keys(dynamicData).length > 0) {
        console.log("Merging Dynamic API data (Priority 2) - fill missing, skip boolean-only fields");
        smartMerge(finalData, dynamicData, trackedFields, "", true);
      }
      
      // 3. Verification API (fills remaining missing fields) - SKIP boolean-only fields
      if (Object.keys(verificationData).length > 0) {
        console.log("Merging Verification API data (Priority 3) - fill missing, skip boolean-only fields");
        smartMerge(finalData, verificationData, trackedFields, "", true);
      }
      
      // 4. DataModel already used as base (lowest priority defaults)
      
      console.log("Final tracked fields:", trackedFields.size, "fields set");
      console.log("Boolean-only fields protected:", booleanOnlyFields.size);
      
      this.ensureRequiredArrays(finalData);

      // Pull out the new dynamic-checklist runtime snapshot stored alongside
      // the legacy DataModel JSON inside TBL_VERIFICATIONCHECKLIST.Current_json.
      const { snapshot: dynamicInitial, persisted: dynamicChecklistPersisted } =
        this.extractDynamicSnapshot(processChecklistData);
      this.setState({
        data: finalData,
        formDataLoading: false,
        dynamicChecklistInitial: dynamicInitial,
        dynamicChecklistPersisted,
        dynamicChecklist: dynamicInitial ?? {
          checklistValues: {},
          repeatableValues: {},
          fieldVerified: {},
        },
        checklistSubmitStatus: readChecklistSubmitStatus(processChecklistData),
        checklistDirty: false,
        checklistSaving: false,
      });
    })
    .catch((error) => {
      console.error("Error fetching form data:", error);
      this.setState({ data: DataModel, formDataLoading: false });
    });
};

/**
 * Pulls the new dynamic-checklist runtime snapshot out of the JSON returned by
 * `get_process_checklist.php`. Returns `null` when no dynamic blob has been
 * saved yet so `DynamicChecklistRuntime` falls back to its master-seeded
 * defaults.
 */
extractDynamicSnapshot = (
  rawJson: any
): { snapshot: DynamicChecklistRuntimeValue | null; persisted: boolean } => {
  if (!rawJson || typeof rawJson !== "object") {
    return { snapshot: null, persisted: false };
  }
  const dyn = rawJson.dynamic;
  if (!dyn || typeof dyn !== "object") {
    return { snapshot: null, persisted: false };
  }
  return {
    persisted: true,
    snapshot: {
      checklistValues: seedLegacyChecklistRestoreKeys(
        rawJson,
        dyn.checklistValues && typeof dyn.checklistValues === "object"
          ? { ...dyn.checklistValues }
          : {}
      ),
      repeatableValues:
        dyn.repeatableValues && typeof dyn.repeatableValues === "object"
          ? Object.keys(dyn.repeatableValues).reduce<
              Record<string, Record<string, string>[]>
            >((acc, k) => {
              const rows = dyn.repeatableValues[k];
              acc[k] = Array.isArray(rows)
                ? rows.map((r: any) => ({ ...(r || {}) }))
                : [];
              return acc;
            }, {})
          : {},
      fieldVerified:
        dyn.fieldVerified && typeof dyn.fieldVerified === "object"
          ? { ...dyn.fieldVerified }
          : {},
    },
  };
};

// Helper function to ensure all required arrays exist
ensureRequiredArrays = (data: any) => {
  const sectionsWithArrays = [
    { path: 'surveyNoVerification.titleDeed', defaultValue: DataModel.surveyNoVerification.titleDeed[0] },
    { path: 'surveyNoVerification.currentPatta', defaultValue: DataModel.surveyNoVerification.currentPatta[0] },
    { path: 'surveyNoVerification.register', defaultValue: DataModel.surveyNoVerification.register[0] },
    { path: 'deed.saleDeed', defaultValue: DataModel.deed.saleDeed[0] },
    { path: 'deed.giftDeed', defaultValue: DataModel.deed.giftDeed[0] },
    { path: 'deed.settlementDeed', defaultValue: DataModel.deed.settlementDeed[0] },
    { path: 'deed.partitionDeed', defaultValue: DataModel.deed.partitionDeed[0] },
    { path: 'deed.willDeed', defaultValue: DataModel.deed.willDeed[0] },
    { path: 'deed.leaseDeed', defaultValue: DataModel.deed.leaseDeed[0] },
    { path: 'deed.attorneyDeed', defaultValue: DataModel.deed.attorneyDeed[0] },
    { path: 'deed.releaseDeed', defaultValue: DataModel.deed.releaseDeed[0] },
    { path: 'deed.rectificationDeed', defaultValue: DataModel.deed.rectificationDeed[0] },
    { path: 'deed.consentDeed', defaultValue: DataModel.deed.consentDeed[0] },
    { path: 'missingLOD.sheets', defaultValue: DataModel.missingLOD.sheets[0] },
    { path: 'legalHeirsVerify.legalHeirs', defaultValue: DataModel.legalHeirsVerify.legalHeirs[0] },
    { path: 'HsdpattasVerify.Hsdpattas', defaultValue: DataModel.HsdpattasVerify.Hsdpattas[0] },
    { path: 'propertytax.propertytax', defaultValue: DataModel.propertytax.propertytax[0] },
    { path: 'EBreceiptData.EBreceipt', defaultValue: DataModel.EBreceiptData.EBreceipt[0] },
  ];

  sectionsWithArrays.forEach(({ path, defaultValue }) => {
    const keys = path.split('.');
    let current = data;
    
    for (let i = 0; i < keys.length - 1; i++) {
      if (!current[keys[i]]) {
        current[keys[i]] = {};
      }
      current = current[keys[i]];
    }
    
    const lastKey = keys[keys.length - 1];
    if (!current[lastKey] || !Array.isArray(current[lastKey]) || current[lastKey].length === 0) {
      current[lastKey] = [{ ...defaultValue }];
    }
  });
};

handleGeneralVerifyChange = (modData) => {
    const { data } = this.state;
    data.generalVerification = modData;
    this.setState({ data });
  };
  handleHsdpattaChange = (modData) => {
    const { data } = this.state;
    data.HsdpattasVerify = modData;
    this.setState({ data });
  };
  handleNathampattaChange = (modData) => {
    const { data } = this.state;
    data.nathamPattaverify = modData;
    this.setState({ data });
  };
  handleFlowChange = (modData) => {
    const { data } = this.state;
    data.flow = modData;
    this.setState({ data });
  };
  handlePropertytaxChange = (modData) => {
    const { data } = this.state;
    data.propertytax = modData;
    this.setState({ data });
  };
  handleEBreceiptChange = (modData) => {
    const { data } = this.state;
    data.EBreceiptData = modData;
    this.setState({ data });
  };
  handleSurveyNoVerifyChange = (modData) => {
    const { data } = this.state;
    data.surveyNoVerification = modData;
    this.setState({ data });
  };
  handleDeedChange = (modData) => {
    const { data } = this.state;
    data.deed = modData;
    this.setState({ data });
  };
  handleLegalHerisChange = (modData) => {
    const { data } = this.state;
    data.legalHeirsVerify = modData;
    this.setState({ data });
  };
  handleEcVerifyChange = (modData) => {
    const { data } = this.state;
    data.ecVerify = modData;
    this.setState({ data });
  };
  handleLodChange = (modData) => {
    const { data } = this.state;
    data.missingLOD = modData;
    this.setState({ data });
  };
  handleVerifyChange = (modData) => {
    const { data } = this.state;
    data.verification = modData;
    this.setState({ data });
  };
  handleCourtVerifyChange = (modData:any) => {
    const { data } = this.state;
    data.courtDocVerification = modData;
    this.setState({ data });
  };
  handleOriginalDocVerifyChange = (modData) => {
    const { data } = this.state;
    data.originalDocVerification = modData;
    this.setState({ data });
  };

  handleBackNavigation = () => {
    const fileId = String(this.props?.match?.params?.id ?? "").trim();
    if (!fileId) {
      this.props.history.push("/");
      return;
    }
    this.props.history.push({
      pathname: `/work-file/4/${fileId}`,
      state: { fromCheckPage: true, previousStep: "step4" },
    });
  };

  persistChecklist = (submit: boolean) => {
    const { data, dynamicChecklistApi, dynamicChecklist, checklistSaving, checklistDirty } =
      this.state;
    const props: any = this.props;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    if (checklistSaving || !checklistDirty) return;
    if (submit && !data.remarks) {
      ToastsStore.error("Enter Remarks!");
      return;
    }

    const dynamic = dynamicChecklistApi
      ? dynamicChecklistApi.getValue()
      : dynamicChecklist;
    if (submit) {
      const missing = dynamicChecklistApi ? dynamicChecklistApi.validate() : [];
      if (missing.length > 0) {
        showRequiredFieldsToast(missing);
        return;
      }
    }

    const checklistSubmitStatus = submit
      ? CHECKLIST_SUBMIT_STATUS.SUBMITTED
      : CHECKLIST_SUBMIT_STATUS.DRAFT;
    const mergedCurrent = buildDynamicChecklistPersistPayload(
      dynamic,
      checklistSubmitStatus,
      data.remarks
    );
    const obj = {
      fileNo: props.match.params.id,
      currentData: mergedCurrent,
      oldData: mergedCurrent,
      loginId: userId,
    };
    const runMappedSync = () =>
      dynamicChecklistApi && dynamicChecklistApi.syncMappedValues
        ? dynamicChecklistApi.syncMappedValues()
        : Promise.resolve();

    this.setState({ checklistSaving: true });

    callApi("POST", "process_checklist.php", obj)
      .then((res) => res.data)
      .then(() => {
        return runMappedSync().catch((err) => {
          console.log(err);
          ToastsStore.warning(
            "Checklist saved, but some mapped values could not sync to source forms."
          );
        });
      })
      .then(() => {
        // Keep current runtime values on screen. Updating initialValue here
        // remounts/re-prefills DynamicChecklistRuntime from scrutiny APIs and
        // can overwrite the extent the user just saved.
        this.ignoreChecklistDirty = true;
        this.setState({
          dynamicChecklistPersisted: true,
          checklistSubmitStatus,
          checklistDirty: false,
        });
        ToastsStore.success(
          submit
            ? "Process checklist saved and submitted"
            : "Process checklist saved as draft"
        );
        // Mapped GD/survey values changed — refresh Software Generated Copy.
        this.reloadSoftwareGeneratedCopy();
        this.setState({ checklistSaving: false }, () => {
          if (!submit) return;
          const fileId = String(this.props?.match?.params?.id ?? "").trim();
          if (fileId) {
            this.props.history.push({
              pathname: `/work-file/4/${fileId}`,
              state: { fromCheckPage: true, previousStep: "step4" },
            });
            return;
          }
          this.props.history.push("/");
        });
      })
      .catch((err) => {
        console.log(err);
        ToastsStore.error("Could not save process checklist.");
        this.setState({ checklistSaving: false });
      });
  };

  handleDynamicChecklistChange = (v: DynamicChecklistRuntimeValue) => {
    if (this.ignoreChecklistDirty) {
      this.ignoreChecklistDirty = false;
      this.setState({ dynamicChecklist: v });
      return;
    }
    this.setState({ dynamicChecklist: v, checklistDirty: true });
  };

  saveDraft = () => this.persistChecklist(false);

  saveAndSubmit = () => this.persistChecklist(true);

  render() {
    const {
      data,
      rotation,
      velocityEqualToMove,
      enableVelocity,
      highlights,
      isHightlightsLoaded,
      base,
      docToPreview,
      checklistSaving,
      checklistDirty,
    } = this.state;
    const checklistSaveDisabled = checklistSaving || !checklistDirty;
    console.log("data------------", data.missingLOD);
    const iframeSourcesoftware = this.state.overviewReport ?? "";

    return (
      <div className="pcoded-content sop">
        <ToastsContainer
          store={ToastsStore}
          position={ToastsContainerPosition.TOP_RIGHT}
        />
        <div className="pcoded-inner-content">
          <div className="main-body">
            <div className="page-wrapper">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="row">
                      <div className="col-md-12 mt-2">
                        {this.state.isOnLoading && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i className="fa fa-spinner fa-spin"></i>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="card-header row">
                      <div className="col-md-5 row">
                        <h5
                          className="font-weight-bold text-uppercase"
                          style={{ alignSelf: "center" }}
                        >
                          Work File Process Check List
                        </h5>
                        <div style={{ width: "50%" }}>
                          {this.state.allDocuments &&
                            this.state.allDocuments.length > 0 && (
                              <div style={{ minWidth: "40%" }}>
                                {this.state.allDocuments &&
                                  this.state.allDocuments.length > 0 &&
                                  this.state.allDocuments.map((opt: any) => {
                                    opt.label =
                                      "Document - " +
                                      opt.id +
                                      (opt.status == 1
                                        ? "- (Not Related)"
                                        : "");
                                    opt.value = opt.base_id;
                                  }) && (
                                    <Select
                                      options={this.state.allDocuments}
                                      name="selectedDoc"
                                      value={this.state.allDocuments.find(
                                        (o: any) =>
                                          o.value === this.state.selectedDoc
                                      )}
                                      onChange={(e) =>
                                        this.viewDocument(e.value)
                                      }
                                    />
                                  )}
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="col-md-7">
                        <button
                          className="btn btn-secondary float-right"
                          onClick={this.handleBackNavigation}
                        >
                          Back
                        </button>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6">
                          <div>
                            <div className="container">
                              <ul
                                className="nav nav-tabs"
                                id="myTab"
                                role="tablist"
                              >
                                <li className="nav-item">
                                  <a
                                    className="nav-link active"
                                    id="old-view-tab"
                                    data-toggle="tab"
                                    href="#old-viewer"
                                    role="tab"
                                    aria-controls="home"
                                    aria-selected="true"
                                  >
                                    Old Viewer
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className="nav-link"
                                    id="new-view-tab"
                                    data-toggle="tab"
                                    href="#new-viewer"
                                    role="tab"
                                    aria-controls="profile"
                                    aria-selected="false"
                                    onClick={() =>
                                      this.setState({ docToPreview: false })
                                    }
                                  >
                                    New Viewer
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className="nav-link"
                                    id="new-view-tab"
                                    data-toggle="tab"
                                    href="#software-view1"
                                    role="tab"
                                    aria-controls="profile"
                                    aria-selected="false"
                                  >
                                    Software Generated Copy
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className="nav-link"
                                    id="hint-about-tab"
                                    data-toggle="tab"
                                    href="#hint-about-view"
                                    role="tab"
                                    aria-controls="hint-about"
                                    aria-selected="false"
                                  >
                                    Hint About
                                  </a>
                                </li>
                              </ul>
                              <div className="tab-content" id="tab-content">
                                <div
                                  className="tab-pane fade show active"
                                  id="old-viewer"
                                  role="tabpanel"
                                  aria-labelledby="old-viewer"
                                >
                                  <TabKeyBlocker scopeToContainer={true}>

                                    <div className="iframe-container">
                                      <iframe
                                        src={this.document.base}
                                        width="100%"
                                        height={this.state.documentHeight}
                                      />
                                      <div className="top-overlay"></div>
                                      <div className="bottom-overlay"></div>
                                    </div>
                                  </TabKeyBlocker>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="new-viewer"
                                  role="tabpanel"
                                  aria-labelledby="new-viewer"
                                >
                                  <p style={{ color: "red" }}>
                                    NOTE: TO HIGHLIGHT [ ALT + RIGHT CLICK ON
                                    MOUSE AND DRAG ]
                                  </p>
                                  <br />
                                  <div
                                    className="App"
                                    style={{
                                      display: "flex",
                                      height: "calc(90vh - 110px)",
                                    }}
                                  >
                                    <TransformWrapper
                                      pan={{
                                        disabled: true,
                                        velocityEqualToMove,
                                        velocity: enableVelocity,
                                      }}
                                      wheel={{
                                        disabled: true,
                                      }}
                                    >
                                      {({
                                        zoomIn,
                                        zoomOut,
                                        resetTransform,
                                        ...rest
                                      }) => (
                                        <React.Fragment>
                                          <div className="tools">
                                            <Rotate90DegreesCcwIcon
                                              className="pdf-icon rotate-icon"
                                              onClick={this.rotate}
                                            />
                                            <ZoomInIcon
                                              className="pdf-icon"
                                              onClick={zoomIn}
                                            />
                                            <ZoomOutIcon
                                              className="pdf-icon"
                                              onClick={zoomOut}
                                            />
                                            <FullscreenExitIcon
                                              className="pdf-icon"
                                              onClick={resetTransform}
                                            />
                                            {base && isHightlightsLoaded && (
                                              <FullscreenIcon
                                                className="pdf-icon"
                                                onClick={() =>
                                                  this.setState({
                                                    docToPreview: true,
                                                  })
                                                }
                                              />
                                            )}
                                          </div>
                                          <TransformComponent>
                                            <div
                                              style={{
                                                height: "calc(90vh - 110px)",
                                                width: "45vw",
                                                position: "relative",
                                                transform: `rotate(${rotation}deg)`,
                                              }}
                                            >
                                              {base && !docToPreview && (
                                                <PdfHighlighter
                                                  key={`inline-${this.state.selectedDoc || base}`}
                                                  url={base}
                                                  onHighlightsChange={
                                                    this.onHighlightsChange
                                                  }
                                                  highlights={highlights}
                                                />
                                              )}
                                            </div>
                                          </TransformComponent>
                                        </React.Fragment>
                                      )}
                                    </TransformWrapper>
                                  </div>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="software-view1"
                                  role="tabpanel"
                                  aria-labelledby="software-view1"
                                >
                                  <div className="iframe-container">
                                    {iframeSourcesoftware ? (
                                      <iframe
                                        src={iframeSourcesoftware}
                                        width="100%"
                                        height={this.state.documentHeight}
                                      />
                                    ) : (
                                      <div className="text-center">
                                        {this.state.generationTimedOut ? (
                                          <>
                                            <h4 style={{ color: "#c0392b" }}>
                                              {this.state.generationError ||
                                                "Document generation failed."}
                                            </h4>
                                            {!isDocGenWorkerDownError(
                                              this.state.generationError,
                                            ) ? (
                                            <button
                                              type="button"
                                              className="btn btn-primary mt-2"
                                              onClick={this.retryDocumentGeneration}
                                            >
                                              Retry
                                            </button>
                                            ) : null}
                                          </>
                                        ) : (
                                          <h4>
                                            <span>
                                              Loading... {this.state.timer}{" "}
                                              seconds
                                            </span>
                                          </h4>
                                        )}
                                      </div>
                                    )}
                                    <div className="top-overlay"></div>
                                    <div className="bottom-overlay"></div>
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="hint-about-view"
                                  role="tabpanel"
                                  aria-labelledby="hint-about-tab"
                                >
                                  <div
                                    style={{
                                      border: "1px solid #dee2e6",
                                      borderRadius: "8px",
                                      height: "675px",
                                      overflow: "auto",
                                    }}
                                  >
                                    <HintAboutFile
                                      id={this.props.match.params.id}
                                      path="workfileQA"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="container">
                            <ul
                              className="nav nav-tabs"
                              id="myTab"
                              role="tablist"
                            >
                              <li className="nav-item">
                                <a
                                  className="nav-link active"
                                  id="old-view-tab"
                                  data-toggle="tab"
                                  href="#verify-view"
                                  role="tab"
                                  aria-controls="home"
                                  aria-selected="true"
                                >
                                  Checklist
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className="nav-link"
                                  id="new-view-tab"
                                  data-toggle="tab"
                                  href="#software-view"
                                  role="tab"
                                  aria-controls="profile"
                                  aria-selected="false"
                                >
                                  Software Generated Copy
                                </a>
                              </li>
                            </ul>
                            {/* Add onKeyDown handler to root container as extra protection */}

                            <div
                              className="tab-content"
                              id="tab-content"
                              style={{ padding: 0 }}
                            >
                              <div
                                className="tab-pane fade show active"
                                id="verify-view"
                                role="tabpanel"
                                aria-labelledby="verify-view"
                              >
                                <div
                                  style={{
                                    border: "1px solid #dee2e6",
                                    borderRadius: "8px",
                                    height: "675px",
                                  }}
                                >
                                  <div
                                    className="container verify-container"
                                    style={{ height: "675px", width: "100%", position: "relative" }}
                                  >
                                    {this.state.formDataLoading && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          right: 0,
                                          bottom: 0,
                                          backgroundColor: "rgba(255,255,255,0.85)",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          zIndex: 10,
                                          borderRadius: "8px",
                                        }}
                                      >
                                        <div className="text-center">
                                          <div
                                            className="spinner-border text-primary"
                                            role="status"
                                            style={{ width: "3rem", height: "3rem" }}
                                          >
                                            <span className="sr-only">Loading...</span>
                                          </div>
                                          <p className="mt-2 mb-0">Loading Process checklist...</p>
                                        </div>
                                      </div>
                                    )}
                                    <div
                                      style={{
                                        overflow: "auto",
                                        height: "550px",
                                      }}
                                    >
                                      {/*
                                        LEGACY STATIC CHECKLIST — kept for fallback / reference.
                                        Hidden via `{false && (...)}` so React skips the subtree
                                        without throwing away the JSX. The cascade is now driven
                                        by `<DynamicChecklistRuntime>` below, sourced from
                                        `dynamic_checklist_master_get.php` and persisted alongside
                                        the legacy DataModel JSON inside Current_json.
                                      */}
                                      {false && (
                                        <>
                                          <GeneralVerification
                                            data={data.generalVerification}
                                            handleGeneralVerifyChange={
                                              this.handleGeneralVerifyChange
                                            }
                                          />
                                          <SurveyNoVerification
                                            data={data.surveyNoVerification}
                                            handleSurveyNoVerify={
                                              this.handleSurveyNoVerifyChange
                                            }
                                          />
                                          <Deed
                                            data={data.deed}
                                            handleDeedChange={this.handleDeedChange}
                                          />
                                          <LegalHerisVerification
                                            data={data.legalHeirsVerify}
                                            handleLegalHerisChange={
                                              this.handleLegalHerisChange
                                            }
                                          />
                                          <ECVerification
                                            data={data.ecVerify}
                                            handleEcVerifyChange={
                                              this.handleEcVerifyChange
                                            }
                                          />
                                          <MissingLOD
                                            data={data.missingLOD}
                                            handleLodChange={this.handleLodChange}
                                          />
                                          <Verification
                                            data={data.verification}
                                            handleVerifyChange={
                                              this.handleVerifyChange
                                            }
                                          />
                                          <CourtDocVerify
                                            data={data.courtDocVerification}
                                            handleCourtVerifyChange={
                                              this.handleCourtVerifyChange
                                            }
                                          />
                                          <Hsdpatta
                                            data={data.HsdpattasVerify}
                                            handleHsdpattaChange={
                                              this.handleHsdpattaChange
                                            }
                                          />
                                          <Nathampatta
                                            data={data.nathamPattaverify}
                                            handleNathampattaChange={
                                              this.handleNathampattaChange
                                            }
                                          />
                                          <Flow
                                            data={data.flow}
                                            handleFlowChange={this.handleFlowChange}
                                          />
                                          <Propertytax
                                            data={data.propertytax}
                                            handlePropertytaxChange={
                                              this.handlePropertytaxChange
                                            }
                                          />
                                          <EBreceipt
                                            data={data?.EBreceiptData}
                                            handleEBreceiptChange={
                                              this.handleEBreceiptChange
                                            }
                                          />
                                          <OriginalDocVerify
                                            data={data.originalDocVerification}
                                            handleOriginalDocVerifyChange={
                                              this.handleOriginalDocVerifyChange
                                            }
                                          />
                                        </>
                                      )}
                                      {!this.state.formDataLoading && (
                                      <DynamicChecklistRuntime
                                        key={`dc-${this.props.match.params.id}`}
                                        fileId={this.props.match.params.id}
                                        activeDocumentFdId={this.state.selectedDoc}
                                        initialValue={this.state.dynamicChecklistInitial}
                                        persistedSnapshot={this.state.dynamicChecklistPersisted}
                                        onChange={this.handleDynamicChecklistChange}
                                        apiRef={(api) =>
                                          this.setState({ dynamicChecklistApi: api })
                                        }
                                        onPreviewEntryDocument={this.previewDynamicEntryDocument}
                                        title=""
                                      />
                                      )}
                                      <div className="collapse-section">
                                        <Card>
                                          <Card.Header>
                                            <h5>
                                              <b>
                                                * Remarks (if Any)/Any Error
                                                Found?
                                              </b>
                                            </h5>
                                          </Card.Header>
                                          <Card.Body>
                                            <div className="row">
                                              <div className="form-group col-md-12">
                                                <label
                                                  className="label"
                                                  style={{ padding: 0 }}
                                                >
                                                  *Have you found any error/ is
                                                  there any remark for the file?
                                                </label>
                                              </div>
                                            </div>
                                            <div className="row">
                                              <div className="form-group col-md-12">
                                                <textarea
                                                  placeholder="Enter Remarks"
                                                  className="form-control"
                                                  name="remarks"
                                                  value={data.remarks}
                                                  onChange={(e) => {
                                                    this.setState({
                                                      data: {
                                                        ...data,
                                                        [e.target.name]:
                                                          e.target.value,
                                                      },
                                                      checklistDirty: true,
                                                    });
                                                  }}
                                                  ref={this.remarksRef}
                                                />
                                              </div>
                                            </div>
                                          </Card.Body>
                                        </Card>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        marginTop: "32px",
                                      }}
                                    >
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-success"
                                          disabled={checklistSaveDisabled}
                                          title={
                                            checklistSaving
                                              ? "Saving..."
                                              : !checklistDirty
                                                ? "No unsaved changes"
                                                : ""
                                          }
                                          onClick={this.saveDraft}
                                        >
                                          {checklistSaving ? "Saving..." : "Save"}
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-primary ml-2"
                                          disabled={checklistSaveDisabled}
                                          title={
                                            checklistSaving
                                              ? "Saving..."
                                              : !checklistDirty
                                                ? "No unsaved changes"
                                                : ""
                                          }
                                          onClick={this.saveAndSubmit}
                                        >
                                          {checklistSaving ? "Saving..." : "Save & Submit"}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="tab-pane fade"
                                id="software-view"
                                role="tabpanel"
                                aria-labelledby="software-view"
                              >
                                <TabKeyBlocker scopeToContainer={true}>

                                  <div className="iframe-container">
                                    {iframeSourcesoftware ? (
                                      <iframe
                                        src={iframeSourcesoftware}
                                        width="100%"
                                        height="672px"
                                      />
                                    ) : (
                                      <div className="text-center">
                                        {this.state.generationTimedOut ? (
                                          <>
                                            <h4 style={{ color: "#c0392b" }}>
                                              {this.state.generationError ||
                                                "Document generation failed."}
                                            </h4>
                                            {!isDocGenWorkerDownError(
                                              this.state.generationError,
                                            ) ? (
                                            <button
                                              type="button"
                                              className="btn btn-primary mt-2"
                                              onClick={this.retryDocumentGeneration}
                                            >
                                              Retry
                                            </button>
                                            ) : null}
                                          </>
                                        ) : (
                                          <h4>
                                            <span>
                                              Loading... {this.state.timer}{" "}
                                              seconds
                                            </span>
                                          </h4>
                                        )}
                                      </div>
                                    )}
                                    <div className="top-overlay"></div>
                                    <div className="bottom-overlay"></div>
                                  </div>
                                </TabKeyBlocker>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`modal ${this.state.docToPreview ? "open" : ""}`}
              id="new-preview-document"
              role="dialog"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-xl"
                role="document"
                style={{ maxWidth: "90%" }}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close cursor-pointer"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => this.setState({ docToPreview: false })}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div
                    className="modal-body"
                    style={{ transform: `rotate(${this.state.rotation}deg)` }}
                  >
                    {this.state.base && this.state.isHightlightsLoaded && (
                      <PdfHighlighter
                        key={`popup-${this.state.selectedDoc || this.state.base}`}
                        url={this.state.base}
                        onHighlightsChange={this.onHighlightsChange}
                        highlights={this.state.highlights}
                        rotation={this.state.rotation}
                        isPopup
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PocessCheckList;
